import { onAuthStateChanged } from 'firebase/auth';
import {
  Timestamp, addDoc, arrayRemove, arrayUnion, collection, deleteDoc, doc,
  getDoc, getDocs, increment, limit, onSnapshot, orderBy, query,
  serverTimestamp, setDoc, updateDoc, where, writeBatch
} from 'firebase/firestore';
import { httpsCallable } from 'firebase/functions';
import { onValue, ref as databaseRef, update as updateDatabase } from 'firebase/database';
import {
  deleteObject, getDownloadURL, ref as storageRef, uploadBytesResumable
} from 'firebase/storage';
import { auth } from './client';
import { database, db, functions, storage } from './services';
import type { AuthReadyResult } from './Auth';
import { legacyAdapter } from './legacyAdapter';

const initialReady: Promise<AuthReadyResult> = Promise.resolve({ state: 'signed-out', user: null, profile: null });

export const firebaseBridge = {
  auth,
  db,
  functions,
  storage,
  database,
  onAuthStateChanged,
  firestore: {
    Timestamp, addDoc, arrayRemove, arrayUnion, collection, deleteDoc, doc,
    getDoc, getDocs, increment, limit, onSnapshot, orderBy, query,
    serverTimestamp, setDoc, updateDoc, where, writeBatch
  },
  call: <Request = unknown, Response = unknown>(name: string) =>
    httpsCallable<Request, Response>(functions, name),
  storageApi: { deleteObject, getDownloadURL, ref: storageRef, uploadBytesResumable },
  databaseApi: { onValue, ref: databaseRef, update: updateDatabase },
  legacy: legacyAdapter,
  ready: initialReady
};

export type JidokaFirebaseBridge = typeof firebaseBridge;

export const installFirebaseBridge = (ready: Promise<AuthReadyResult>): void => {
  firebaseBridge.ready = ready;
  window.JidokaFirebase = firebaseBridge;
  window.dispatchEvent(new Event('jidoka:firebase-bridge-ready'));
};

declare global {
  interface Window {
    JidokaFirebase: JidokaFirebaseBridge;
  }
}
